import { useModal as useAbstraxtionModal } from '@burnt-labs/abstraxion';
import { useMemo, useState, useEffect } from 'react';
import { useCosmos } from '../../helpers/cosmosHelper';
import { useTaskHelper } from '../../helpers/taskHelper';
import { useGlobalState } from '../../state/GlobalStateProvider';
import { useBackendApi } from '../../helpers/backendHelper';
import utils from '../../utils';
import img from '../Idn_arrow.svg';
import lockIcon from '../lock.svg';
import './BadgeList.scss';

const BadgeList = ({ badges, category }) => {
  const taskHelper = useTaskHelper();
  const [{ isLoggedIn }] = useCosmos();
  const [showAbstraxion, setShowAbstraxion] = useAbstraxtionModal();
  const [{ userIdentity,user }] = useGlobalState();
  const backendApi = useBackendApi();
  const [referralCode, setReferralCode] = useState('');
  const [isLoadingReferralCode, setIsLoadingReferralCode] = useState(false);
  
  const firstUndoneIndex = badges?.findIndex(task => !userIdentity?.claims?.[utils.bsonIdToBytes12(task?.id)]);

  const isStake = category === 'stake';
  const isBridge = category === 'bridge';
  const isInvite = category === 'invite';
  
  const badgeTitle = isStake ? 'STAKOOOR' : isBridge ? 'BRIDGOOOR' : 'INVITOOOR';
  const verificationText = isStake ? 'Verify Stakes' : isBridge ? 'Verify Bridges' : 'Verify Invites';
  const unlockText = isStake ? 'STAKE MORE XION' : isBridge ? 'BRIDGE MORE XION' : 'INVITE MORE FRIENDS';
  // Fetch referral code when user is logged in
  useEffect(() => {
    const fetchReferralCode = async () => {
      if (!user || referralCode) return; // Don't fetch if we already have a code
      
      setIsLoadingReferralCode(true);
      try {
        const response = await backendApi.cosmos.getXionReferralCode();
        const code = response?.code || response?.referralCode;
        if (code) {
          setReferralCode(code);
        }
      } catch (error) {
        console.error('Error fetching referral code:', error);
      } finally {
        setIsLoadingReferralCode(false);
      }
    };

    fetchReferralCode();
  }, [user]); // Removed backendApi from dependencies

  const handleInviteClick = () => {
    if (!user) {
      // Trigger login if user is not logged in
      setShowAbstraxion(true);
      return;
    }

    // If user is logged in and we have a referral code, open Twitter share
    if (referralCode) {
      const twitterUrl = `https://twitter.com/intent/post?text=Join%20me%20in%20building%20XION%20Identity%20profiles!&url=http%3A%2F%2Fxion.mercle.xyz%2Fr%2F${referralCode}`;
      window.open(twitterUrl, '_blank');
    }
  };

  const unlockLink = isStake 
    ? 'https://staking.burnt.com/staking/' 
    : isBridge 
    ? 'https://getxion.com/' 
    : '#';
  const nextUnlock = (badges[firstUndoneIndex]?.name.split(" ")[2]) + (isStake ? ' XION STAKED' : isBridge ? ' XION BRIDGED' : ' INVITE[S]'); 

  const onVerify = useMemo(() => {
    return async task => {
      if (!task) return;
      try {
        await taskHelper.verify(task);
      } catch (e) {
        console.log(e);
      }
    };
  }, [taskHelper]);
  return (
    <div className='badge_container'>
      <div className='stakoor_text'>
        <p>{badgeTitle} BADGES</p>
        <div className='white_line'></div>
      </div>
      <div className='badges_heading'>
        <div className='badges_text'>
          {firstUndoneIndex === 0 ? (
            <div className='title'>
              Claim your first <span>{badgeTitle} BADGE!</span>{' '}
            </div>
          ) : (
            <>
              <div className='title'>
                {badgeTitle}
                <span>STRENGTH {firstUndoneIndex}</span>
              </div>
              <div className='desc'>
                {isStake ? 'Staked' : isBridge ? 'Bridged' : 'Invited'} at least {badges[firstUndoneIndex - 1]?.name.split(' ')[2]} {isStake ? 'XION' : isBridge ? 'XION' : 'friends'} at some point in history.
              </div>
            </>
          )}
        </div>
        <div className='stakes_btn' onClick={()=> isLoggedIn(() =>  {
           
           onVerify(badges[firstUndoneIndex]);
       })}>
          {verificationText}
          <span className='arrow'>
            <img src={img} alt='arrow'></img>
          </span>
        </div>
      </div>
      <div className='card-container'>
        {badges && badges.length > 0 ? (
          badges.map(task => (
            <div key={task?.id} className='nft_preview_border'>
              <img src={task.badge_img} alt='badge' className='badge_img' />

              {(!userIdentity?.claims?.[utils.bsonIdToBytes12(task?.id)] || !user) &&  (
                <div className='lock-overlay'>
                  <img src={lockIcon} alt='Locked' className='lock-icon' />
                </div>
              )}
            </div>
          ))
        ) : (
          <p>No badges available</p>
        )}
      </div>
      <div className='unlock_container'>
        <div className='unlock_text'>
          next unlock at <span>{nextUnlock}</span>
        </div>
        {isInvite ? (
          <div className='stake_more_btn' onClick={handleInviteClick}>
            {isLoadingReferralCode ? 'Loading...' : unlockText}
            <span className='arrow'>
              <img src={img} alt='arrow' />
            </span>
          </div>
        ) : (
          <a href={unlockLink} target='_blank' rel='noopener noreferrer'>
            <div className='stake_more_btn'>
              {unlockText}
              <span className='arrow'>
                <img src={img} alt='arrow' />
              </span>
            </div>
          </a>
        )}
      </div>
    </div>
  );
};

export default BadgeList;
